import { useContext } from 'react';
import { UserContext } from '../context/UserContext';

const UnauthorizedView = () => {
  const { userName } = useContext(UserContext);

  return (
    <div style={{
      display: 'flex',
      width: '100%',
      height: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#ffffff'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        width: '400px',
        height: '300px',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          margin: 'auto',
          display: 'flex',
          width: '400px',
          height: '300px',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div>
            <div style={{
              border: '1px solid #e0e0e0',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '40px'
            }}>
              <div style={{
                backgroundColor: '#ff9800',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '20px'
              }}>
                👤
              </div>
              <div style={{
                paddingTop: '14px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}>
                <div style={{ fontSize: '16px' }}>Welcome</div>
                <div style={{ fontSize: '16px', fontWeight: '500' }}>{userName}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div style={{
            fontSize: '18px',
            color: '#d32f2f',
            padding: '8px 0'
          }}>
            your session is not valid. Please try again later.
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedView;